export default "__VITE_ASSET__BrxLE27G__"